import classnames from 'classnames';
import React from 'react';

import './styles.css';
import { UiSvgIconProps } from './types';

import Icon from '/assets/svg-sprite.svg';

export const UiSvgIcon = React.forwardRef<HTMLSpanElement, UiSvgIconProps>(
  function UiSvgIcon(
    { className, symbol, role = 'img', size = 'default', ...props },
    ref,
  ) {
    return (
      <span
        {...props}
        ref={ref}
        className={classnames(
          'ui-svg-icon',
          size && `ui-svg-icon--${size}`,
          className,
        )}
        role={role}
      >
        <svg aria-hidden="true" width="20" height="20">
          <use href={`${Icon}#${symbol}`} />
        </svg>
      </span>
    );
  },
);
